import TicketsScannerGroupedTicketItems from './GroupedTicketItems'

const TicketsScannerMemberInfo = ({ member, groupedTicketItems }) => {
  const teamsList = member.teams
    .map((team) => team.name + " (" + team.group_name + ")")
    .join(", ")

  const teams = member.teams.length > 0 ? (
    <p>
      <b>{I18n.t("tickets_scanner.owner_info.teams")}: </b>
      {teamsList}
    </p>
  ) : null

  const accepted_shifts = member.shifts_accepted_at ? (
    <i className="fa fa-check text-navy"></i>
  ) : (
    <i className="fa fa-times text-danger"></i>
  )

  const properties = member.properties.map((property) => (
    <div className="col-md-3" key={property.name}>
      <strong>{property.name}: </strong>
      <span
        dangerouslySetInnerHTML={{ __html: property.value || "-" }}
      ></span>
    </div>
  ))

  return (
    <div>
      <div className="row">
        <div className="col-xs-12 col-md-6">
          <img
            src={
              member.profile_image ||
              "https://placehold.co/150x150?text=?"
            }
            className="profile-image img-circle"
            alt=""
          />
          <h2>{member.name}</h2>
          <p>{member.email}</p>
          <p>
            <b>{I18n.t("tickets_scanner.owner_info.accepted_shifts")}: </b>
            {accepted_shifts}
          </p>
          <p>
            <b>{I18n.t("tickets_scanner.owner_info.member_type")}: </b>
            {member.member_type_name}
          </p>
          <p>
            <b>{I18n.t("tickets_scanner.owner_info.total_shift_hours")}: </b>
            {member.total_shift_hours}
          </p>
          <p>
            <b>{I18n.t("tickets_scanner.owner_info.shifts_count")}: </b>
            {member.shifts_count}
          </p>
          <p>
            <b>{I18n.t("tickets_scanner.owner_info.shifts")}:</b>
          </p>
          <ul>
            {member.shifts.map((shift, index) => (
              <li key={index}>
                {shift.long_title}
              </li>
            ))}
          </ul>
          {teams}
        </div>
        <div className="col-xs-12 col-md-6">
          {groupedTicketItems.length > 0 ? (
            <TicketsScannerGroupedTicketItems
              groupedTicketItems={groupedTicketItems}
            />
          ) : (
            ""
          )}
        </div>
      </div>
      <div className="row" style={{ marginTop: "10px" }}>
        {properties}
      </div>
    </div>
  )
}

export default TicketsScannerMemberInfo
